<template>
  <div
    class="
      mx-auto
      my-5
      w-11/12
      bg-brand-red bg-opacity-10
      border-2 border-brand-red
      rounded
      px-8
      py-5
    "
  >
    <slot></slot>
  </div>
</template>
